import React, { Component } from 'react';

import TableStateCard from '../components/TableStateCard';
import { navigateTo } from '../utils/navigation';

var config = process.env;

function money(value) {
    const n = Number(value || 0);
    return `$ ${n.toLocaleString('es-UY')}`;
}

function fmtDate(value) {
    if (!value) return '-';
    return new Date(value).toLocaleString('es-UY');
}

// Panel de carritos armados por los clientes (ENI-68). Lista agregada (GET /carts) +
// detalle del carrito en modal (GET /carts/:accountId).
class TableCartsComponent extends Component {

    constructor() {
        super();
        this.state = {
            data: [],
            loaded: false,
            search: '',
            showModal: false,
            detail: null,
            detailLoading: false,
        };
        // Secuencia para que gane el ÚLTIMO carrito pedido, no la última respuesta en llegar.
        this.detailReq = 0;
    }

    componentDidMount() {
        this.fetchData();
    }

    authHeaders = () => ({
        'access-token': localStorage.getItem('token'),
        'Content-Type': 'application/json',
    });

    fetchData = () => {
        this.setState({ loaded: false });
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}carts`, { method: 'GET', headers: this.authHeaders() })
            .then((r) => r.json())
            .then((data) => {
                if (data.error > 0) {
                    alert(data.message);
                    if (data.error == 1002) window.location.href = localStorage.getItem('homePageURL');
                    this.setState({ loaded: true });
                } else {
                    this.setState({ data: data.data || [], loaded: true });
                }
            })
            .catch(() => this.setState({ loaded: true }));
    }

    openDetail = (accountId) => {
        const reqId = ++this.detailReq;
        this.setState({ showModal: true, detail: null, detailLoading: true });
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}carts/${accountId}`, { method: 'GET', headers: this.authHeaders() })
            .then((r) => r.json())
            .then((data) => {
                if (reqId !== this.detailReq) return; // respuesta vieja: se pidió otro carrito o se cerró
                if (data.error > 0) {
                    alert(data.message);
                    this.setState({ detailLoading: false });
                } else {
                    this.setState({ detail: data.data, detailLoading: false });
                }
            })
            .catch(() => { if (reqId === this.detailReq) this.setState({ detailLoading: false }); });
    }

    closeModal = () => { this.detailReq++; this.setState({ showModal: false, detail: null, detailLoading: false }); };

    clientName = (row) => {
        const name = [row.firstName, row.lastName].filter(Boolean).join(' ').trim();
        return name || row.email || `Cuenta #${row.accountId}`;
    }

    filtered = () => {
        const q = this.state.search.trim().toLowerCase();
        if (!q) return this.state.data;
        return this.state.data.filter((r) =>
            [r.firstName, r.lastName, r.email, r.cedula].filter(Boolean).join(' ').toLowerCase().includes(q));
    }

    detailTotal = () => {
        const items = (this.state.detail && this.state.detail.items) || [];
        return items.reduce((acc, it) => acc + Number(it.price || 0) * Number(it.quantity || 0), 0);
    }

    render() {
        if (!this.state.loaded) {
            return <TableStateCard loading />;
        }

        if (this.state.data.length === 0) {
            return (
                <TableStateCard
                    icon="shopping_cart"
                    title="Todavía no hay carritos para mostrar"
                    message="Cuando los clientes agreguen productos a su carrito desde la tienda, vas a verlos acá con su contenido."
                />
            );
        }

        const rows = this.filtered();
        const d = this.state.detail;
        const accountName = d && d.account
            ? ([d.account.firstName, d.account.lastName].filter(Boolean).join(' ') || d.account.email)
            : '';

        return (
            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                <div id="DataTables_Table_0_filter" className="dataTables_filter">
                    <label>Buscar:
                        <input type="search" placeholder="nombre, correo o cédula" value={this.state.search} onChange={(e) => this.setState({ search: e.target.value })} />
                    </label>
                </div>

                <table className="transaction-history d-none dataTable no-footer dtr-inline" role="grid">
                    <thead>
                        <tr role="row">
                            <th style={{ width: '28%' }}>Cliente</th>
                            <th style={{ width: '12%' }}>Cédula</th>
                            <th className="text-center" style={{ width: '8%' }}>Juegos</th>
                            <th className="text-center" style={{ width: '8%' }}>Unidades</th>
                            <th style={{ width: '15%' }}>Creado</th>
                            <th style={{ width: '15%' }}>Última modificación</th>
                            <th style={{ width: '14%' }}></th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.length === 0 && (
                            <tr><td colSpan="7" style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)' }}>Sin resultados para “{this.state.search}”.</td></tr>
                        )}
                        {rows.map((row, index) => (
                            <tr role="row" className="odd" key={row.accountId} style={{ background: index % 2 == 0 ? '#ffffff' : '#fcfcfc' }}>
                                <td className="sorting_1">{this.clientName(row)}</td>
                                <td>{row.cedula || '-'}</td>
                                <td className="text-center">{row.itemCount}</td>
                                <td className="text-center">{row.totalQty}</td>
                                <td>{fmtDate(row.createdAt)}</td>
                                <td>{fmtDate(row.updatedAt)}</td>
                                <td className="text-right">
                                    <button type="button" className="btn btn-sm btn-white" onClick={() => this.openDetail(row.accountId)}>Ver carrito</button>
                                    {row.cedula ? (
                                        <button type="button" className="btn btn-sm btn-white ml-1" onClick={() => navigateTo(`/clientDetail?cedula=${row.cedula}`)}>Cliente</button>
                                    ) : null}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {this.state.showModal && (
                    <React.Fragment>
                        <div className="modal fade show" role="dialog" style={{ display: 'block' }}>
                            <div className="modal-dialog modal-lg" role="document">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title">Carrito{accountName ? ` — ${accountName}` : ''}</h4>
                                        <button type="button" className="close" onClick={this.closeModal}><span>&times;</span></button>
                                    </div>
                                    <div className="modal-body" style={{ padding: 0 }}>
                                        {this.state.detailLoading && (<div className="text-center p-4">Cargando…</div>)}
                                        {!this.state.detailLoading && d && (
                                            <table className="table mb-0">
                                                <thead className="bg-light">
                                                    <tr>
                                                        <th>Producto</th>
                                                        <th>Código</th>
                                                        <th className="text-center">Cant.</th>
                                                        <th className="text-right">Precio</th>
                                                        <th className="text-right">Subtotal</th>
                                                        <th>Agregado</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {(d.items || []).length === 0 && (
                                                        <tr><td colSpan="6" className="text-center text-muted">Carrito vacío.</td></tr>
                                                    )}
                                                    {(d.items || []).map((it) => (
                                                        <tr key={it.code}>
                                                            <td>{it.prefix ? `${it.prefix} ` : ''}{it.name}</td>
                                                            <td>{it.code}</td>
                                                            <td className="text-center">{it.quantity}</td>
                                                            <td className="text-right">{money(it.price)}</td>
                                                            <td className="text-right">{money(Number(it.price || 0) * Number(it.quantity || 0))}</td>
                                                            <td>{fmtDate(it.created_at)}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                {(d.items || []).length > 0 && (
                                                    <tfoot>
                                                        <tr>
                                                            <td colSpan="4" className="text-right"><strong>Total</strong></td>
                                                            <td className="text-right"><strong>{money(this.detailTotal())}</strong></td>
                                                            <td></td>
                                                        </tr>
                                                    </tfoot>
                                                )}
                                            </table>
                                        )}
                                    </div>
                                    <div className="modal-footer">
                                        <button className="mb-2 mr-1 btn btn-primary btn-sm" onClick={this.closeModal}>Cerrar</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-backdrop fade show" onClick={this.closeModal}></div>
                    </React.Fragment>
                )}
            </div>
        );
    }
}

export default TableCartsComponent;
